import React, { useEffect, useState } from 'react';
import arrow_enter from '../../../images/quiz/Arrow.png'
import Button from '../Button';

import './NextButton.css';

const NextButton = (props) => {
    let cl = props.className ? props.className : ""
    cl += "next-button"
    return <Button {...props} pill className={cl} ><img src={arrow_enter} /></Button>};

export default NextButton;